export const route = {
  dashboard: 'Panel główny',
  statistics: 'Statystyki',
  configuration: 'Szablony konfiguracji',
  flows: 'Szablony konfiguracji',
  files: 'Pliki',
  new: 'Nowy szablon konfiguracji',
  roles: 'Role',
  users: 'Użytkownicy',
  configurationFinished: 'Zakończone szablony konfiguracji',
  profile: 'Profil',
  packages: 'Pakiety',
  createConfiguration: 'Tworzenie szablonu konfiguracji',
  login: 'Logowanie',
  editor: 'Edytor',
  landingPage: 'Strona główna',
  pathway: 'Konfigurator',
  resetPassword: 'Resetowanie hasła',
  verifyEmail: 'Weryfikacja adresu e-mail',
  blockly: 'Edytor reguł',
  configurationsFinished: 'Zakończony szablon konfiguracji',
  configurationsSummary: 'Podsumowanie konfiguracji',
  logs: 'Logi',
}
